module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-backplates.080b7077.png";